import React from 'react';
import Icofont from 'react-icofont';
import { useDispatch, useSelector } from 'react-redux';
import { getRoundTwo } from 'src/helpers/decimal';
import { submitPolizasPagar } from 'src/reducer/action/pago';
import { removeAlert } from "src/reducer/action/alert";

const ResumenPago = ({ step, stepForward, stepBackwards, fixed = false }) => {

  const dispatch = useDispatch()
  const { polizas: polizasPagar } = useSelector(state => state.pago.pagar)


  const submitPagar = e => {
    e.preventDefault()

    const polizasPagarCheck = polizasPagar.filter(value => value.CHECK === true)

    if (!isNaN(getTotalPagar())) {
      dispatch(submitPolizasPagar(polizasPagarCheck))
      stepForward(step)
    } else {
      alert('ERROR')
    }
  }

  const getTotalPagar = () => {
    return getRoundTwo(
      polizasPagar
        .filter(value => value.CHECK === true)
        .reduce(
          (acumulador, value) => (acumulador += getRoundTwo(value.PAGAR)),
          0
        )
    )
  }

  const getValidaciones = () => {
    if (isNaN(getTotalPagar()) || getTotalPagar() <= 0) {
      return true
    }

    const polizasPagarCheckMontoPagar = polizasPagar
      .filter(value => value.CHECK === true)
      .every(value => value.PAGAR >= 3)

    if (!polizasPagarCheckMontoPagar) {
      return true
    }

    return false
  }
  return (
    <div
      style={{
        position: fixed ? 'fixed' : 'static',
        bottom: fixed ? 0 : 'auto',
        left: 0,
        width: '100%',
        backgroundColor: fixed ? '#fff' : 'transparent',
        padding: fixed ? '1rem' : '0',
        borderTop: fixed ? '1px solid #e5e5e5' : 'none',
        zIndex: 1000,
        textAlign: 'center',
      }}
    >
      <div className='text-center btn-container-responsive'>
        <div>
          <span className='font-weight-bold text-dark fw-bold'>TOTAL:</span>
          <h2 className='font-weight-bold d-inline-block text-primary' >
            ${getTotalPagar().toFixed(2)}
          </h2>
        </div>
        <p

          style={{
            fontSize: '14px',
            padding: '0px 0px 7px 0px;',
            margin: 0
          }}
          className='text-muted'>
          {polizasPagar.filter(value => value.CHECK === true).length > 0 ? `Seleccionadas ${polizasPagar.filter(value => value.CHECK === true).length} pólizas` : ''}
        </p>
        {step === 0 && (

          <button
            onClick={submitPagar}
            className='btn-pay btn-pay-mobile-full'
            disabled={getValidaciones()}
          >
            Continuar
            <Icofont icon='arrow-right' />
          </button>
        )}

        {
          step > 0 && (
            <>
              <button
                onClick={() => {

                  dispatch(removeAlert(null))
                  stepBackwards(step)
                  
                }}
                className="btn btn-dark"
                style={{ minWidth: fixed ? '60%' : '120px', padding: fixed ? '10px' : '0px 0px 10px 0px;' }}
              >
                <Icofont icon='arrow-left' />
                Regresar
              </button>
              <br />
            </>

          )
        }
      </div>
    </div>
  );
};

export default ResumenPago;
